import { render } from "./DataTableHeaderCell.vue?vue&type=template&id=2267af63"
import script from "./DataTableHeaderCell.vue?vue&type=script&lang=js"
export * from "./DataTableHeaderCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__